export const localStorageKey = "STORK_SESSION_START_TIME";
export const sessionLength = 1000 * 60 * 60; /* 60 minutes */

// calculate all times minus small timePadding
// to prevent situation when back end session actually ends before client session
export const timePadding = 10 * 1000; /* 10 seconds */

export const dialogTimeLength = 1000 * 60 * 2; /* 2 minutes */
